import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";
export enum ConversationResponder {
  USER = "user",
  AI = "ai",
}

export const MIN_MAX_QUESTIONS = 2;
export const MAX_MAX_QUESTIONS = 10;

export const AiReturnReasonStepSettingsSchema = z.object({
  maxQuestions: z.number(),
  merchantGuidance: z.string().nullish(),
});

export type AiReturnReasonStepSettings = z.infer<
  typeof AiReturnReasonStepSettingsSchema
>;

export const AiReturnReasonConversationSchema = z.array(
  z.object({ role: createEnum(ConversationResponder), message: z.string() }),
);

export type AiReturnReasonConversation = z.infer<
  typeof AiReturnReasonConversationSchema
>;
// State schema for the return reason categorization agent
export const ReturnReasonStateSchema = z.object({
  teamId: z.string(),
  draftReturnId: z.string(),
  returnableItemId: z.string(),
  finalCategory: z.string().nullish(),
  isDamaged: z.boolean().nullish(),
  isWrongProduct: z.boolean().nullish(),
  isExchange: z.boolean().nullish(),
  conversation: AiReturnReasonConversationSchema,
  aiReturnReasonStep: AiReturnReasonStepSettingsSchema.nullish(),
  hasFetchedCategories: z.boolean().nullish(),
  productInfo: z.string().nullish(), //Stored on state in case product gets deleted or name changes.
  previousReturnChatThreadIds: z.array(z.string()).nullish(),
});
export type ReturnReasonState = z.infer<typeof ReturnReasonStateSchema>;
